export default __webpack_public_path__ + "media/images/back_image-6cdfe5e00e45fc79d3e3bd19b34a29df.png";